
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">Гуми Европа</Link>
      </div>
      <button className="navbar-toggle" onClick={() => setOpen(o => !o)} aria-label="Toggle menu">
        <span className="navbar-toggle-bar"></span>
        <span className="navbar-toggle-bar"></span>
        <span className="navbar-toggle-bar"></span>
      </button>
      <ul className={`navbar-links${open ? ' open' : ''}`} onClick={() => setOpen(false)}>
        <li><Link to="/">Начало</Link></li>
        <li><Link to="/pricing">Ценоразпис</Link></li>
        <li><Link to="/book">Запазете час</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
